export default __webpack_public_path__ + "static/tag-dont-5-dark-ba824efe7824a30426fc17399ede620c.png";